import { forwardRef } from "react";

export const LightningIcon = forwardRef<SVGSVGElement, { className?: string }>(
  ({ className }, ref) => {
    return (
      <svg
        ref={ref}
        width="12"
        height="14"
        viewBox="0 0 12 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className || ""}
      >
        <path
          d="M3.33366 13.6654L4.00033 8.9987H0.666992L6.66699 0.332031H8.00033L7.33366 5.66536H11.3337L4.66699 13.6654H3.33366Z"
          fill="var(--swapper-primary-color)"
        />
      </svg>
    );
  },
);
